export default {"src":"/_next/static/media/reebelo-badge.98857676.svg","height":70,"width":148,"blurWidth":0,"blurHeight":0};